var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFavorites = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.56 6.734a5.82 5.82 0 0 1-1.617 4.04c-2.387 2.474-4.703 5.054-7.18 7.44a1.43 1.43 0 0 1-2.01-.045l-7.136-7.395c-2.156-2.236-2.156-5.845 0-8.08a5.46 5.46 0 0 1 7.904 0l.26.268.258-.268A5.5 5.5 0 0 1 14.991 1a5.5 5.5 0 0 1 3.952 1.694 5.82 5.82 0 0 1 1.618 4.04"
})));
export default SvgFavorites;